module.exports = __webpack_public_path__ + "static/homephoto-b0d8ec54cd22157d4952d68ccdb09a76.jpg";